module.exports = __webpack_public_path__ + "img/tab22.8ea40f67.png";